// extracted by mini-css-extract-plugin
export default {"container":"yFMQU","header":"eBq86","form-container":"ebcgJ","form-item":"zkzA0","amount-input":"k1Okk","alert":"o_vuQ"};